// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentMethodItem_root_2LbaK","orderNumber":"PaymentMethodItem_orderNumber_3vH2W","amountInput":"PaymentMethodItem_amountInput_2Jqv3"};